import {call, put} from "redux-saga/effects";
import {getPackageApi} from "../../../../common/apis/packageApi";
import {
    createNouvelleSouscriptionApi,
    existForfaitAvecMemeExerciceApi,
    getSouscriptionSituationApi,
} from "../../../../common/apis/souscriptionApi";
import * as actions from "../state/nouvelleSouscriptionActions";

export function* getPackageForSouscriptionSaga({ payload }) {
  try {
    const response = yield call(getPackageApi, payload);
    yield put(
      actions.getPackageForSouscriptionSuccessAction(response.data.body)
    );
  } catch (error) {
    yield put(actions.getPackageForSouscriptionFailAction(error));
  }
}

export function* creationNouvelleSouscriptionSaga({ payload }) {
  try {
    const response = yield call(createNouvelleSouscriptionApi, payload);
    yield put(
      actions.creationNouvelleSouscriptionSuccessAction(response.data.body)
    );
  } catch (error) {
    yield put(actions.creationNouvelleSouscriptionFailAction(error));
  }
}



export function* getSouscriptionSituationSaga({ payload }) {
  try {
    const response = yield call(getSouscriptionSituationApi, payload);
    yield put(
        actions.creationNouvelleSouscriptionSuccessAction(response.data.body)
    );
  } catch (error) {
    yield put(actions.creationNouvelleSouscriptionFailAction(error));
  }
}


export function* existForfaitAvecMemeExerciceSaga({ payload }) {
  try {
    const response = yield call(existForfaitAvecMemeExerciceApi, payload);
    console.log(response.data);
    yield put(actions.existForfaitAvecMemeExerciceSuccessAction(response.data));
  } catch (error) {
    yield put(actions.existForfaitAvecMemeExerciceFailAction(error));
  }
}
